<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-columns', fontSet: 'fad'}"
	[headerText]="T.CONFIGURE_APPLICATION_TILE_DIALOG_TITLE | translate"
	[matDialogData]="data"
	[rect]="rect"
	class="normalDuotoneHeaderIcon"
>
	<ng-container dialogContent>
		<div class="availableApplications">
			@for (application of APPLICATIONS; track application) {
				@if (hasCustomPrerequisites(application)) {
					<div
						(click)="selectApplication(application.id)"
						[class.disabled]="alreadyUsed(application.id)"
						[class.selected]="selectedApplication === application.id"
						class="application"
						mat-ripple
					>
						<div class="applicationIcon">
							<img [src]="baseHref + '/assets/icons/appIcons/' + application.icon + '.svg'" alt="appIcon" height="35px" />
						</div>
						<div class="applicationDescription">
							<div class="applicationHeader">
								{{ application.header | translate }}
							</div>
						</div>
					</div>
				}
			}
		</div>
	</ng-container>

	<ng-container actions>
		<!--
    -42 is used as a 'code' to inform the settings dashboard dialog to remove this tile
    -->
		<sim-button
			(onClick)="close({action: 'ok', newClientApplication: -42})"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-trash-alt'}"
			[label]="T.CONFIGURE_APPLICATION_TILE_DIALOG_REMOVE_TILE"
			color="warn"
			style="margin-right: 15px"
		/>

		<sim-button
			(onClick)="close({action: 'cancel'})"
			[icon]="{fontSet: 'fal', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
			color="warn"
			style="margin-right: 15px"
		/>

		<sim-button
			(onClick)="okClicked()"
			[disabled]="selectedApplication === null"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
